import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { ICache, SearchPageCacheReadyEvent } from '@studyportals/search-page-interface';
import { injectable } from 'inversify';
import { EventAggregationService } from './EventAggregationService';

@injectable()
export class Cache implements ICache, ISubscriber<SearchPageCacheReadyEvent> {
	private _target: ICache | null = null;

	private readonly eventAggregationService: EventAggregationService;

	public constructor(eventAggregationService: EventAggregationService) {
		this.eventAggregationService = eventAggregationService;
		this.eventAggregationService.subscribeTo(SearchPageCacheReadyEvent.EventType, this, true);
	}

	public get<T>(key: string): T | null {
		if (this._target) {
			return this._target.get(key);
		}

		return null;
	}

	public set<T>(key: string, value: T): void {
		if (this._target) {
			this._target.set(key, value);
		}
	}

	public remove(key: string): void {
		if (this._target) {
			this._target.remove(key);
		}
	}

	public notify(event: SearchPageCacheReadyEvent): void {
		this._target = event.cache;
	}
}
